<template>
  <Layout title="Counterparties | Account">
    <Title
      icon="account"
      heading="Your Account"
      sub-heading="Manage your account settings and more."
    />

    <div class="container my-4"><div class="row"><div class="col"><h2>Counterparties</h2></div></div></div>

    <div class="container" v-if="counterParties.length === 0">
      <div class="row">
        <div class="col mb-4">
          <p>You currently have no Counterparties, meaning you have no agreements setup on Clausify.</p>
          <p>If this is incorrect, please contact <a href="mailto:help@clausify.co">help@clausify.co</a></p>
        </div>
      </div>
    </div>

    <div class="container"  v-if="counterParties.length > 0">
      <div class="row">
        <div class="col">
          <div id="counterParties">
            <CounterParty
              v-for="(counterParty, index) in counterParties"
              :key="counterParty.id"
              :index="index"
              :counterParty="counterParty"
              :organisation="organisation"
              :allAssetTypes="allAssetTypes"
              :assetTypes="assetTypes"
              :errors="errors"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="container">
        <button v-if="!showAddNewCounterParty" @click="showAddNewCounterParty = true" class="btn btn-primary mt-2" type="button">Add New Counterparty</button>
        <form class="card mt-3" v-if="showAddNewCounterParty" @submit.prevent="addCounterparty">
          <div class="card-header">
            <h5 class="mb-0">Add new Counterparty</h5>
          </div>
          <div class="card-body">
            <div class="form-group">
              <TextInput
                v-model="form.name"
                :errors="errors ? errors.name : []"
                type="text"
                autofocus
                autocapitalize="off"
                label="Who is the Counterparty? (Business name)"
                @input="errors.name = []"
                validateSuccess
                validateError
              />
            </div>

            <div class="form-group">
              <TextInput
                v-model="form.registered_number"
                :errors="errors ? errors.registered_number : []"
                type="text"
                autofocus
                autocapitalize="off"
                label="Registered Number"
                @input="errors.registered_number = []"
                validateSuccess
                validateError
              />
            </div>

            <div class="form-group">
              <TextArea
                label="Address"
                v-model="form.address"
                :errors="errors ? errors.address : []"
                autofocus
                autocapitalize="off"
                rows="4"
                @input="errors.address = []"
                validateSuccess
                validateError
              />
            </div>

            <div class="form-group">
              <div class="row">
                <div class="col-md-3 flex">
                  <LoadingButton
                    :loading="form.processing"
                    class="btn btn-primary btn-block"
                    type="submit"
                    >Create</LoadingButton
                  >
                  <button class="btn btn-secondary btn-block" @click.prevent="showAddNewCounterParty = false">Cancel</button>
                </div>
              </div>
            </div>
          </div>
        </form>
    </div>


  </Layout>
</template>

<script>
import helpers from '@/Mixins/helpers';
import Layout from '@/Shared/Layout';
import Title from '@/Shared/Title';
import LoadingButton from '@/Shared/LoadingButton';
import TextInput from '@/Shared/Inputs/Text';
import TextArea from '@/Shared/Inputs/Textarea';
import CounterParty from './CounterParty.vue';

export default {
  mixins: [helpers],

  components: {
    Title,
    Layout,
    CounterParty,
    TextInput,
    TextArea,
    LoadingButton,
  },

  props: {
    errors: Object,
    organisation: Object,
    counterParties: Array,
    allAssetTypes: Array,
    assetTypes: Array,
  },

  data() {
    return {
      showAddNewCounterParty: false,
      form: this.$inertia.form(this.formSetup()),
    }
  },

  methods: {

    formSetup() {
      return {
        name: '',
        address: '',
        registered_number: '',
      }
    },

    addCounterparty() {
      const route = this.route('counter-party.store');

      this.form.post(`${route}?redirect=back`, {
        preserveState: true,
        preserveScroll: true,
        onSuccess: () => {
          this.form = this.$inertia.form(this.formSetup());
        },
      });
    }
  }
};
</script>
